import { useSelector } from 'react-redux';

import 'react-quill/dist/quill.snow.css';
// import '../utils/quilMention.js';

import * as PropTypes from 'prop-types';
import { useTranslate } from '@tolgee/react';

import { COMMUNICATION_ENABLE_NOTES } from '../../constants';
import FeaturesToolTip from '../../../featuresToolTip';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function TextAreaSettings({
  setMessageSettings,
  messageSettings
}) {
  const { t } = useTranslate();
  const { userData } = useSelector((state) => state.userDetails);
  return (
    <div
      className={`d-inline-flex flex-row card rounded-pill p-1 px-2 fw-bold bg-light mx-1 user-select-none`}

    >
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            <span>{t('communication.textArea.reply_tooltip')}</span>
          </Tooltip>
        }
      >
        <div
          className={` ${
            !messageSettings.is_internal_note ? 'card' : ''
          } cursor-pointer rounded-pill p-2 px-3 user-select-none`}
          onClick={() => setMessageSettings({ is_internal_note: false })}
          style={{
            boxShadow: !messageSettings.is_internal_note
              ? '0 1px 7px rgba(0,0,0,.085)'
              : '',
                              resize: 'none'

          }}
        >
          {t('communication.textArea.reply')}
        </div>
      </OverlayTrigger>
      <div className="mx-1" />
      <FeaturesToolTip
        featureIsActive={
          userData?.feature_list_for_user[COMMUNICATION_ENABLE_NOTES]
        }
        feature={COMMUNICATION_ENABLE_NOTES}
        InnerComponent={() => {
          return (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  <span>{t('communication.textArea.note_tooltip')}</span>
                </Tooltip>
              }
            >
              <div
                className={` ${
                  messageSettings.is_internal_note ? 'card' : ''
                } ${
                  userData?.feature_list_for_user[COMMUNICATION_ENABLE_NOTES]
                    ? 'cursor-pointer'
                    : ''
                } rounded-pill p-2 px-3 user-select-none`}

                onClick={() => {
                  if (
                    userData?.feature_list_for_user[COMMUNICATION_ENABLE_NOTES]
                  )
                    setMessageSettings({ is_internal_note: true });
                }}
                style={{
                  boxShadow: messageSettings.is_internal_note
                    ? '0 1px 7px rgba(0,0,0,.085)'
                    : '',
                }}
              >
                {t('communication.textArea.note')}
              </div>
            </OverlayTrigger>
          );
        }}
      />
    </div>
  );
}
TextAreaSettings.propTypes = {
  setMessageSettings: PropTypes.func,
  messageSettings: PropTypes.object
};
